import {i18n} from "ui/i18n";

export default (query, ...args) => {
	args = args.filter(v => typeof v === 'string' || typeof v === 'number');
	return i18n(query, ...args);
}
